// constants that are shared between css and js
// trying to minimize sources of truth as much as possible
export const CARD_ASPECT_RATIO = 1.35;
export const LAYOUT_BREAKPOINT = 768;
export const CARD_FACTOR = 25;
export const GAP_FACTOR = 2.5;
export const MAX_GAP = 50;
export const CARD_MAX_WIDTH = 500;

// these layout arrays represent the two different layouts for the grid
// each index contains a tuple that represents the position in the grid [x, y]
// which gets multiplied by card dimensions in css and js

/* prettier-ignore */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const DESKTOP_LAYOUT = [
               [1.5, 0], [2.5, 0],
     [0.5, 1], [1.5, 1], [2.5, 1], [3.5, 1],
[0.0, 2], [1.0, 2], [2.0, 2], [3.0, 2], [4.0, 2],
     [0.5, 3], [1.5, 3], [2.5, 3], [3.5, 3],
               [1.5, 4], [2.5, 4],
];
export const DESKTOP_ROWS = 5;
export const DESKTOP_COLUMNS = 5;

/* prettier-ignore */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const MOBILE_LAYOUT = [
        [1, 0],
[0, 1], [1, 1], [2, 1],
[0, 2], [1, 2], [2, 2],
[0, 3], [1, 3], [2, 3],
[0, 4], [1, 4], [2, 4],
[0, 5], [1, 5], [2, 5],
        [1, 6],
];
export const MOBILE_ROWS = 7;
export const MOBILE_COLUMNS = 3;
